
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from 'react-router-dom';

import QuotesList from "./QuotesList";
import SingleQuote from "./SingleQuote";


const SearchResults = () => {
    const location = useLocation();
    const query =  new URLSearchParams(location.search).get("q").replace(/[^a-zA-Z\d\s:]/, "")
   
    const [quotes, setQuotes] = useState([]);

    const [first, setFirst] = useState([]);
    const [firstKeywords, setFirstKeywords] = useState([]);

    const [total, setTotal] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [perPage, setPerPage] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
  
    const [loading, setLoading] = useState(false);
  
    const fetchQuotes = async (pageNumber) => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_STOIC_SEARCH}/${query}?page=${pageNumber}&limit=18`
        );
        setQuotes(response.data.results);
        if (response.data.results.length === 1) {
          setFirst(response.data.results[0])
          setFirstKeywords(response.data.results[0].keywords)
        }
        setTotal(response.data.total_results);
        setTotalPages(response.data.total_pages);
        setPerPage(response.data.per_page);
        setCurrentPage(response.data.page);
        setLoading(false);    

      } catch (error) {
        return error;
      }
    };
    
    useEffect(() => {
      fetchQuotes(1);
    }, []);
  
    return (
        <div>
            {loading? 
            (<div>Loading...</div>) 
              : quotes.length > 1 ? 
              (<QuotesList
                quotes={quotes}
                total={total}
                totalPages={totalPages}
                perPage={perPage}
                currentPage={currentPage}
                fetchQuotes={fetchQuotes}
                loading={loading}
                query={query}
                />)
              : 
              (
               <SingleQuote singleQuote={first} singleQuoteKeywords={firstKeywords} />
              )
              }
        </div>
    );
};

export default SearchResults;
